module.exports = __webpack_public_path__ + "img/fbc05c6.jpg";